import React from "react";
import "./ProductDetail125.css";

const ProductDetail125 = () => {
  return (
    <div className="tpms-container">
      <div className="tpms-wrapper">
        
        {/* LEFT IMAGE */}
        <div className="tpms-left">
          <img
            src="ImagesNew/Hero-Image-2-LR.png"  // <-- apni image yaha daal
            alt="Toll Monitoring"
          />
          <div className="badge">✔ NHAI Verified System</div>
        </div>

        {/* RIGHT CONTENT */}
        <div className="tpms-right">
          <p className="subtitle">THE SOLUTION</p>

          <h1>
            Introducing TPMS – <br />
            <span className="smart">Smart Toll Monitoring</span>
          </h1>

          <p className="desc">
            TPMS is a next-generation AI-powered toll monitoring system that
            automates, monitors, and optimizes toll operations in real time.
            With intelligent surveillance, OCR-based vehicle detection, and
            centralized analytics.
          </p>

          <div className="features">
            <span>✔ Accurate Toll Collection</span>
            <span>✔ Real-Time Monitoring</span>
            <span>✔ Fraud Detection</span>
            <span>✔ Data-Driven Decisions</span>
          </div>

          <button className="cta-btn">
            Explore TPMS →
          </button>
        </div>

      </div>
    </div>
  );
};

export default ProductDetail125;